import React from 'react';
import styles from './TermsAndConditions.module.scss';

const TermsAndConditions = ({ termsTitle, termsText }) => {
  // 如果从首页传递了数据，使用它；否则使用默认内容
  const title = termsTitle?.value || termsTitle || 'Terms and conditions';
  const content =
    termsText?.value ||
    termsText ||
    'Offer valid for private retail only upon taking a test drive. Not available to Fleet customer or Motability customers. The £500 (incl. VAT) is redeemable against the purchase of a new JAECOO 7 ordered and registered between 2nd June and 30th June 2025. Offer can be used in conjunction with the 3.9% APR finance offer. Available at participating retailers only. This offer cannot be used in conjunction with any other promotions or discounts. For full details, please contact your local OMODA & JAECOO dealer. OMODA & JAECOO UK Limited reserves the right to amend or withdraw this offer at any time without prior notice.';

  // 如果 termsText 是 HTML 格式，直接使用 dangerouslySetInnerHTML
  if (termsText && (termsText.value || termsText).includes('<')) {
    return (
      <div className="container">
        <div className={styles.container}>
          <div className={styles.wrapper} data-aos="fade-up">
            <h2>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    );
  }

  // 否则使用普通文本
  return (
    <div className="container">
      <div className={styles.container}>
        <div className={styles.wrapper} data-aos="fade-up">
          <h2>{title}</h2>
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
